import {formatDateTime} from "./datehelpers";

export function replaceSubject(subject, variables = {}, pov = "third") {
  subject = replaceVars(subject, variables);
  // console.log(subject);
  return subject;
}

export function replaceBody(body, variables = {}, pov = "third") {
  body = replaceVars(body, variables);
  console.log(variables);
  // console.log(body);
  return body;
}

function replaceVars(body, variables) {
  let reg = /\{[a-zA-Z0-9]+\}/m;
  while (reg.test(body)) {
    body = body.replace(reg, function (match) {
      let variable = match.replace('{', "").replace('}', "");
      console.log(variables[variable]);
      if (!variables[variable]) {
        console.log("Missing: ", variable);
        return "";
      }
      console.log(variable, Date.parse(variables[variable]));
      if (!isNaN(Date.parse(variables[variable]))) {
        return formatDateTime(new Date(variables[variable]));
      } else if (variable === "bizCard" || variable === "repBizCard"){
        return `##inlineImage|careers/${variables[variable]}|${variable}|DO_NOT_ALTER##`
      } else {
        return variables[variable];
      }
    });
  }
  return body;
}


// WEBPACK FOOTER //
// ./src/util/templateHelpers.js